import { render, staticRenderFns } from "./CallbackEbay.vue?vue&type=template&id=52e01216"
import script from "./CallbackEbay.vue?vue&type=script&lang=ts"
export * from "./CallbackEbay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports